import microuniversoApi from "app/api/microuniversoApi";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { FiltroListarVendedores } from "app/types/comissoes/Vendedores";
import { IOrcamento } from "app/types/IOrcamento";
import { Vendedor } from "app/types/Vendedor";
import { tratamentoErroPadrao } from "app/use-cases";
import { adicionarVendedores } from "app/use-cases/orcamento/comissoes/vendedores";
import globalMU from "globalMU";
import React from "react";
import { useState } from "react";
import { useAppSelector } from "../../../redux/hooks";
import { DadosAbaVendedores, PesquisaAbaVendedores } from "./PesquisaAbaVendedores";

export type VendedoresContainerProps = {
    mostrarBotaoCancelar: boolean;
    onAlteradoDadosAbaVendedores: (dados: DadosAbaVendedores) => void
    onExibeAdicionarVendedor: (valor: boolean) => void;
}

export const VendedoresContainer = (props: VendedoresContainerProps & DadosAbaVendedores) => {
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)
    const [vendedores, setVendedores] = useState<Partial<PagedMessageResponse<Vendedor>>>(props.vendedores)
    const [filtroVendedores, setFiltroVendedores] = useState<FiltroListarVendedores>(props.abaVendedores)

    const pesquisarVendedores = async (filtros: FiltroListarVendedores) => {
        try {
            globalMU.blockUI();
            setFiltroVendedores({ ...filtros, IdentificadorOrcamento: orcamento.IdentificadorOrcamento });
            const vendedoresPesquisados = await microuniversoApi.Orcamento.listarVendedores({
                Codigo: filtros?.Codigo,
                IdentificadorOrcamento: orcamento.IdentificadorOrcamento,
                Nome: filtros?.Nome,
                NumeroPagina: filtros?.NumeroPagina ?? 1,
                TamanhoPagina: filtros?.TamanhoPagina ?? 20
            });
            !("HasErrors" in vendedoresPesquisados) && setVendedores(vendedoresPesquisados);
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    const onEnviarVendedores = async (vendedores: Vendedor[]) => {
        if (vendedores.length == 0) {
            globalMU.showErrorMessage("Selecione o(s) vendedor(es) a ser(em) adicionado(s).")
            return
        }

        try {
            globalMU.blockUI();
            const resultado = await adicionarVendedores(vendedores);

            if (!("HasErrors" in resultado)) {
                props.onExibeAdicionarVendedor(true)
                globalMU.showSuccessMessage("Vendedor(es) adicionado(s) com sucesso")
            } else {
                props.onExibeAdicionarVendedor(true);
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
        }
    }

    return (
        <>
            <PesquisaAbaVendedores
                abaVendedores={filtroVendedores}
                vendedores={vendedores}
                vendedoresSelecionados={props.vendedoresSelecionados}
                corSelecionada={globalMU.sessionStorage.getData('UsuarioLogado')?.CorFundo}
                textoSelecionado={globalMU.sessionStorage.getData('UsuarioLogado')?.CorTexto}
                mostrarCancelar={props.mostrarBotaoCancelar}
                somenteLeitura={orcamento.SomenteLeitura}
                onCancelar={() => props.onExibeAdicionarVendedor(true)}
                onPesquisarVendedores={pesquisarVendedores}
                onEnviarVendedores={onEnviarVendedores}
                onAlteradoDadosAbaVendedores={props.onAlteradoDadosAbaVendedores}
            />
        </>
    )

}